<script setup>
import SubmitButton from '@/components/Forms/Buttons/SubmitButton.vue'
import { onMounted, ref } from 'vue'
import { useAuthStore } from '@/stores/authStore.js'
import { userApi } from '@/api/User/UserApi.js'
import { Toaster } from '@/models/utils/Toaster.js'
import LoadingSpinner from '@/components/Spinners/LoadingSpinner.vue'
import InputText from '@/components/Forms/InputText.vue'

const toaster = new Toaster()

const tenant = ref(null)
const tenant_settings = ref({})
const tenant_name = ref(null)
const hostname = ref(null)
const email_sender = ref(null)
const session_timeout = ref(null)
const jwt_ttl = ref(null)
const isSaving = ref(false)
const isLoading = ref(false)
const error = ref(null)

const nonEmptyNumberFilter = (event, callback) => {
	if (event.target.value === '') {
		event.target.value = '0'
		callback(event.target.value)
	}
}

const beforeEditNumber = (event, callback) => {
	if (event.target.value === '0' && event.data) {
		event.target.value = ''
		callback(event.target.value)
	}
}

onMounted(() => {
	isLoading.value = true

	userApi.getTenantById(useAuthStore().getAuth.user().tenant_id, (tenantData) => {
		tenant.value = tenantData
		tenant_settings.value = JSON.parse(tenant.value.settings_json)

		tenant_name.value = tenant.value.name
		hostname.value = tenant.value.host
		email_sender.value = tenant.value.email_from

		session_timeout.value = tenant_settings.value.session_timeout_hours.value
		jwt_ttl.value = tenant_settings.value.jwt_ttl.value

		isLoading.value = false
	})
})

function save() {
	const settings = {
		'session_timeout_hours': session_timeout.value,
		'jwt_ttl': jwt_ttl.value,
	}

	error.value = null
	isSaving.value = true
	userApi.updateTenantSettings({ settings: settings },
		() => {
			isSaving.value = false
			toaster.success('Settings successfully updated!')

			userApi.refreshUserData()
		}, (e) => {
			error.value = e.showErrorBanner()
			isSaving.value = false
		})
}

</script>

<template>
	<LoadingSpinner v-if="isLoading" />

	<div v-if="!isLoading">
		<div class="flex space-x-4 mt-4">
			<InputText label="Tenant name" type="text" v-model="tenant_name" :disabled="true"/>
			<InputText label="Hostname" type="text" v-model="hostname" :disabled="true"/>
			<InputText label="Email sender" type="text" v-model="email_sender" :disabled="true"/>
		</div>

		<InputText class="w-fit" label="Session timeout (hours)" type="number" v-model="session_timeout" :errors="error" error-field="settings.session_timeout_hours" input-width="w-20" tooltip-location="right" tooltip-width="w-fit" :tooltip="tenant_settings.session_timeout_hours?.description" :input-filter="(event) => nonEmptyNumberFilter(event, (val) => session_timeout = val)" :before-input="(event) => beforeEditNumber(event, (val) => session_timeout = val)"/>
		<InputText class="w-fit" label="JWT TTL (minutes)" type="number" v-model="jwt_ttl" input-width="w-20" :errors="error" error-field="settings.jwt_ttl" tooltip-location="right" tooltip-width="w-fit" :tooltip="tenant_settings.jwt_ttl?.description" :input-filter="(event) => nonEmptyNumberFilter(event, (val) => jwt_ttl = val)" :before-input="(event) => beforeEditNumber(event, (val) => jwt_ttl = val)"/>

		<SubmitButton label="Save" @click="save" size="small" :disabled="isSaving" :loading="isSaving"/>
	</div>
</template>